import { mutationOptions } from '@tanstack/react-query'

import { gozokiApiWithAuth } from '../gozokiApi'
import { keys } from '../queries/keys'

export interface SetFeatureFlagVariables {
  name: string
  enabled: boolean
}

export const setFeatureFlag = async ({ name, enabled }: SetFeatureFlagVariables) => {
  const response = await gozokiApiWithAuth.put<{ message: string }>(
    `/feature-flags/${encodeURIComponent(name)}`,
    { enabled },
  )
  return response.data
}

export const setFeatureFlagMutationOptions = () =>
  mutationOptions({
    mutationFn: setFeatureFlag,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.featureFlags.list() })
      context.client.invalidateQueries({ queryKey: keys.rbac.permissions.current() })
    },
  })
